
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promo/[slug]/[[...level]]",
      function () {
        return require("private-next-pages/promo/[slug]/[[...level]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promo/[slug]/[[...level]]"])
      });
    }
  